/* global swal, axios, videojs, WaveSurfer, Plyr */

// eslint-disable-next-line no-unused-vars
const lsKeys = {}
const headerDesktop = document.querySelector('#ads-header-desktop')
const headerMobile = document.querySelector('#ads-header-mobile')
const footerDesktop = document.querySelector('#ads-footer-desktop')
const footerMobile = document.querySelector('#ads-footer-mobile')
// eslint-disable-next-line no-unused-vars

const aads = ''

const page = {
  urlPrefix: null,
  urlIdentifier: null,
  uploadRoot: null,
  titleFormat: null,
  player: null,
  lazyLoad: null
}

const loadAds = () => {
  if (!localStorage.getItem('token')) {
    headerDesktop.innerHTML = atob(aads)
    page.waystone()
  } else {
    headerDesktop.innerHTML = atob(aads)
  }
}

page.formatBytes = (bytes, decimals = 2) => {
  if (bytes === 0) return '0 Bytes'

  const k = 1024
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']

  const i = Math.floor(Math.log(bytes) / Math.log(k))
  return parseFloat((bytes / Math.pow(k, i)).toFixed(decimals)) + ' ' + sizes[i]
}

page.onInitFile = () => {
  const pathArray = window.location.pathname.split('/')
  const slugIndex = pathArray.indexOf('f') + 1
  const slug = pathArray[slugIndex]

  return axios
    .get(`https://api.cyberdrop.cr/api/file/info/${slug}`, {})
    .then((response) => {
      if (!response.data) {
        return swal('An error occurred!', 'File details not found', 'error')
      } else {
        page.file = response.data
        document.getElementById('file-name').textContent = response.data.name
        document.getElementById('file-size').textContent = page.formatBytes(response.data.size)
        document.getElementById('identifier').value = response.data.url

        page.urlInput = document.querySelector('#identifier')
        page.reloadBtn = document.querySelector('#reloadBtn')
        page.downloadBtn = document.querySelector('#downloadBtn')
        page.videoContainer = document.querySelector('#playerContainer')
        //page.lastVisit()
        page.showFile(response.data.auth_url, response.data.type)
      }
    })
    .catch((error) => {
      console.log('Error caught in onInitFile:', error)
      page.onAxiosError(error)
    })
}

//page.lastVisit = () => {
//  return axios
//    .post(`../api/f/last_visit`, { type: 'file', fileid: page.file.slug })
//    .then((response) => {
//      if (response.data.success === false) {
//        return swal('An error occurred!', response.data.description, 'error')
//      } else {
//        // Handle success if necessary
//      }
//    })
//    .catch(page.onInitError)
//}

// Disable video.js telemetry (should already be disabled by default since v7 though)
window.HELP_IMPROVE_VIDEOJS = false

// Handler for regular JS errors
page.onError = (error) => {
  console.error(error)

  const content = document.createElement('div')
  content.innerHTML = `
    <p><code>${error.toString()}</code></p>
    <p>Please check your console for more information.</p>
  `
  return swal({
    title: 'An error occurred!',
    icon: 'error',
    content
  })
}

// Handler for Axios errors
page.onAxiosError = (error) => {
  // Log the error for debugging
  console.log('Axios Error:', error)

  // Check if error.response exists
  if (!error.response) {
    // Handle cases where error.response is undefined
    return swal('Error', 'An unknown error occurred', 'error')
  }

  // Better Cloudflare errors
  const cloudflareErrors = {
    520: 'Unknown Error',
    521: 'Web Server Is Down',
    522: 'Connection Timed Out',
    523: 'Origin Is Unreachable',
    524: 'A Timeout Occurred',
    525: 'SSL Handshake Failed',
    526: 'Invalid SSL Certificate',
    527: 'Railgun Error',
    530: 'Origin DNS Error'
  }

  // Handle 429 Too Many Requests error
  if (error.response.status === 429) {
    return swal('Too Many Requests', 'You have made too many requests. Please try again later.', 'error')
  }

  const statusText = cloudflareErrors[error.response.status] || error.response.statusText
  const description =
    error.response.data && error.response.data.description
      ? error.response.data.description
      : ''

  return swal(`${error.response.status} ${statusText}`, description, 'error')
}

page.toggleReloadBtn = (enabled) => {
  if (enabled) {
    page.reloadBtn.classList.remove('is-loading')
    page.reloadBtn.removeAttribute('disabled')
  } else {
    page.reloadBtn.classList.add('is-loading')
    page.reloadBtn.setAttribute('disabled', 'disabled')
  }
}

document.addEventListener('DOMContentLoaded', (event) => {
  page.reloadVideo = (authURL, contentType) => {
    page.toggleReloadBtn(false)
    axios
      .get(authURL)
      .then((response) => {
        if (![200, 304].includes(response.status)) {
          page.toggleReloadBtn(true)
          return page.onAxiosError(response)
        }

        // Fetch the URL from the response
        const src = response.data.url
        console.log("Video Source URL: ", src)  // Debugging statement
        console.log("Content Type: ", contentType)  // Debugging statement
        const isVideo = contentType.startsWith('video/')
        const isAudio = contentType.startsWith('audio/')
        const isImage = contentType.startsWith('image/')

        if (isImage) {
          const imgContainer = document.querySelector('#imageContainer')
          console.log("Image Container: ", imgContainer)  // Debugging statement
          const imgElement = document.createElement('img')
          imgElement.setAttribute('src', src)
          imgContainer.append(imgElement)
        } else if (isVideo || isAudio) {
          page.urlIdentifier = src

          if (page.player) {
            page.player.destroy() // Destroy existing player if any
          }

          page.videoContainer.innerHTML = '' // Clear existing content
          console.log("Video Container Cleared")  // Debugging statement

          // Create and configure the video element for Plyr
          const videoElement = document.createElement('video')
          videoElement.id = 'player'
          videoElement.className = 'plyr__video-embed'
          videoElement.setAttribute('controls', '')
          videoElement.innerHTML = `<source src="${src}" type="${contentType}">`
          console.log("Video Element Created: ", videoElement)  // Debugging statement

          page.videoContainer.appendChild(videoElement)
          console.log("Video Element Appended to Container")  // Debugging statement

          // Plyr setup
          const videoOptions = {
            debug: false,
            tooltips: {
              controls: true
            },
            controls: [
              'play-large',
              'play',
              'progress',
              'current-time',
              'mute',
              'volume',
              'settings',
              'pip',
              'fullscreen'
            ],
            autoplay: false,
            ratio: '16:9'
          }

          page.player = new Plyr('#player', videoOptions)
          console.log("Plyr Player Initialized")  // Debugging statement
        }

        if (page.downloadBtn) {
          page.downloadBtn.setAttribute('href', src)
        }

        page.toggleReloadBtn(true)
      })
      .catch((error) => {
        page.toggleReloadBtn(true)
        if (typeof error.response !== 'undefined') {
          page.onAxiosError(error)
        } else {
          page.onError(error)
        }
      })
  }

  page.showFile = (authURL, contentType) => {
    // Prevent default form's submit action
    const form = document.querySelector('#inputForm')
    form.addEventListener('submit', (event) => {
      event.preventDefault()
    })

    page.reloadBtn = document.querySelector('#reloadBtn')
    if (page.reloadBtn) {
      page.reloadBtn.addEventListener('click', (event) => {
        if (!form.checkValidity()) return
        page.reloadVideo(authURL, contentType)
      })
    }

    page.reloadVideo(authURL, contentType)
  }
})

window.addEventListener('DOMContentLoaded', () => {
  page.onInitFile()
})
